<template>
  <div>
    <Header/>
    <b-card class="bCardGlobalXL">
      <b-row class="divSubtitulo m-1 mb-3">
        <b-col cols="6" md="8">
          <div>
            <p class="textoSubtitulo">Catálogo de Colorimetros</p>
          </div>
        </b-col>
        <b-col cols="6" md="4">
          <div>
            <p style="text-align: end" class="textoSubtitulo">Catalogo_colorimetro Lab</p>
          </div>
        </b-col>
      </b-row>


      <div class="d-flex justify-content-center w-100 mt-4">
        <div class="busqueda d-flex mt-4" style="width: 50%; margin-top: 10px;" >
          <b-form-input class="input-filter" v-model="filter" placeholder="Búsqueda de colorimetro" type="text">
          </b-form-input>
          <b-button class="btn-extra-small" variant="info">
            <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px; border-radius: 20px;"></em></span>
          </b-button>
        </div>
        <div style="margin-left: 6px;">
          <b-button variant="primary" pill style="background: #1B81AF" size="sm" class="mt-4" @click="abrirModalColorimetro = true" disabled>
            <em class="escaner_svg mt-1"
                style="filter: brightness(0) invert(1);"
                v-b-tooltip.hover.topright.v-light
                title="Agregar Colorimetro"
                v-if="$localStorageService.can('colorimetros_lab_nuevo')"
            ></em>
          </b-button>
        </div>
      </div>

      <div class="col-12 mt-5">
        <!--        <br>-->
        <b-row class="contenedorTablaSinColor">
          <b-col sm="12" md="12" lg="12">
            <b-table
                id="labs"
                class="parrafos"
                fixed
                :fields="headersTabla"
                :items="listaColorimetros"
                :per-page="$registrosPorPaginaTabla"
                :current-page="paginaActual"
                responsive
                thead-tr-class="columnasTablaSinColor"
                caption-top
            >
              <template #cell(flujo)="row">
                <div v-for="r in row.item.flujo" :key="r.idTipoFlujoFisico" >
                  {{r.nombre}},
                </div>
              </template>
              <template #cell(fechaModificacion)="row">
                {{ row.item.fechaModificacion | formatoFechaCorta }}
              </template>
              <template #cell(Acciones)="row">
                <div class="text-center">
                  <em v-if="row.item.registroActivo && $localStorageService.can('colorimetros_lab_editar')" class= "edit_outline_svg" style="width: 21px; cursor: pointer"
                      @click="editarColorimetro(row.item);"
                      v-b-tooltip.hover.topleft.v-light
                      title="Editar"
                  ></em>
                  <em v-else-if="$localStorageService.can('colorimetros_lab_inactivar')" class= "activar_kit" style="width: 21px; cursor: pointer"
                      @click="cambiarEstatus(row.item)"
                  ></em>

                  <em  v-if="row.item.registroActivo && $localStorageService.can('colorimetros_lab_inactivar')" class= "trash_svg" style="margin-left: 4px; cursor: pointer"
                       v-b-tooltip.hover.topright.v-light
                       title="Inactivar"
                       @click="cambiarEstatus(row.item)"
                  ></em>
                </div>
              </template>

            </b-table>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal v-model="abrirModalColorimetro" size="lg" hide-footer hide-header no-close-on-backdrop no-close-on-esc >
      <div class="row">
        <div class="col-10 d-flex" style="color: #044169; margin-top: -4px; font-weight: 600; width: 90%">
          <em class="escaner_svg" style="height: 60%; margin-top: 5px"></em>
          <span class="textSize ml-2" style="font-weight: 600;margin-top: 5px;" >Edición de Colorimetro</span>
        </div>
        <div class="col-2 text-right">
          <em class="close_equis_svg" style="width: 12%; cursor: pointer" @click="abrirModalColorimetro = false"
              v-b-tooltip.hover.topright.v-light
              title="Cerrar"
          />
        </div>
      </div>

      <ModalColorimetro
          :listaTipoFlujoFisico="listaTipoFlujoFisico"
          :objColorimetro="objColorimetro"
          :editar="editar"
          @cerrarModal="cerrarModal"
          @obtenerColorimetros="obtenerColorimetros"
      />
    </b-modal>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import ModalColorimetro from "@/views/catalogos/Laboratorio/Colorimetros/ModalColorimetro.vue";

export default {
  name: "Colorimetros",
  components: {ModalColorimetro, Header},
  data:  () => ({
    headersTabla: [
      {key: "idColorimetro", label: "id  Colorimetro", sortable: false},
      {key: "nombre", label: "Nombre", sortable: false},
      {key: "flujo", label: "Flujo", sortable: false},
      {key: "fechaModificacion", label: "Fecha Modificación", sortable: false},
      "Acciones"
    ],
    paginaActual:1,
    listaColorimetros: [],
    listaTipoFlujoFisico: [],
    abrirModalColorimetro: false,
    objColorimetro: null,
    editar: false,
    filter: null
  }),
  created() {
    this.obtenerTiposFlujoFisico();
    this.obtenerColorimetros();
  },
  methods: {
    cambiarEstatus(item){
      const guardar = {
        idColorimetro: item.idColorimetro
      }

      this.$swal.fire({
        icon: "warning",
        html: '<p><strong>¿Estás seguro de cambiar el estatus de '+ item.nombre + ' ?</strong></p>',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#EEBA6D",
        preConfirm: () => {
          this.$http.post(this.$api + "labs/cambiarEstatus/colorimetro", guardar).then(respuesta => {
            if (respuesta.data.data) {
              this.$swal({
                icon: "success",
                text: "Se guardó correctamente la información ",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
                onClose: () => {
                  this.obtenerColorimetros();
                }
              })
            }
          })
        }
      })
    },
    cerrarModal(){
      this.abrirModalColorimetro = false;
    },
    editarColorimetro(item){
      this.editar = true;
      this.objColorimetro = item;
      this.abrirModalColorimetro = true
    },
    obtenerTiposFlujoFisico(){
      this.$http.get(this.$api + "labs/listaFlujoFisico")
          .then((response) => {
            this.listaTipoFlujoFisico = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() =>{});
    },
    obtenerColorimetros(){
      this.abrirModalColorimetro = false;
      this.$http.get(this.$api + "labs/listarColorimetros")
          .then((response) => {
            this.listaColorimetros = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() =>{});
    },
  }
}
</script>
<style scoped>
.busqueda {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 20px;
  margin-left: 4%;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}
</style>